import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { useHistory } from 'react-router-dom';
import {
  LuCalendarRange, LuFileSearch, LuFileText, LuScale, LuUsers,
} from 'react-icons/lu';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';

import {
  DateFilter,
  Field,
  FilterStyles,
  Section,
} from '../../components/FilterKit';

interface SearchData {
  proc_cod_cliente: number;
  proc_cod_adv_resp: number;
  description: string;
  proc_data_ajuiz_inicio: Date | undefined;
  proc_data_ajuiz_final: Date | undefined;
  proc_reg: string;
  proc_num_pasta: string;
  proc_autor: string;
  proc_reu: string;
}

const SearchManagement:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  // const startOfMonth = moment().startOf('month').format('YYYY-MM-DD hh:mm:ss');
  // const endOfMonth = moment().endOf('month').format('YYYY-MM-DD hh:mm:ss');

  const [attorneysOptions, setAttorneysOptions] = useState([{}]);
  const [attorneyInChargeId, setAttorneyInChargeId] = useState(0);
  const [lawsuitRegistrationNumber, setLawsuitRegistrationNumber] = useState('');
  const [lawsuitFolderNumber, setLawsuitFolderNumber] = useState('');
  const [author, setAuthor] = useState('');
  const [defendant, setDefendant] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [description, setDescription] = useState('');

  const [
    initialRegistrationDate, setInitialRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [
    finalRegistrationDate, setFinalRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);

  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [dateFilterType, setDateFilterType] = useState('data');

  const handleClear = (resetForm: () => void) => {
    setAttorneyInChargeId(0);
    setLawsuitRegistrationNumber('');
    setLawsuitFolderNumber('');
    setAuthor('');
    setDefendant('');
    setCustomerId('');
    setDescription('');
    setInitialRegistrationDate(null);
    setFinalRegistrationDate(null);
    setDateFilterType('data');
    resetForm();
  };

  const validationSchema = null;

  useEffect(() => {
    (async () => {
      await api.get('customers/show/all').then((response) => {
        response.data.map((customer:
        {
          cliente_id: number,
          cliente_nome:string
        }) => (
          customersOptions.push({
            name: customer.cliente_nome,
            value: customer.cliente_id,
          })
        ));
      });
      customersOptions.splice(0, 1);

      setCustomersOptions(customersOptions);
      // setCustomersOptions((oldOptions) => [...oldOptions, customersOptions]);
    })();
  }, [customersOptions]);

  useEffect(() => {
    (async () => {
      attorneysOptions.push({
        name: 'Todos',
        value: 0,
      });
      await api.get('management/attorneys/show/all').then((response) => {
        response.data.map((attorney:
        {
          advogado_id: number,
          advogado_nome:string
        }) => (
          attorneysOptions.push({
            name: attorney.advogado_nome,
            value: attorney.advogado_id,
          })
        ));
      });
      attorneysOptions.splice(0, 1);
      setAttorneysOptions(attorneysOptions);
    })();
  }, [attorneysOptions]);

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      // const access = JSON.parse(sessionStorage.getItem('@Jurisnet:access') || '{}');
      const access = JSON.parse(localStorage.getItem('@Jurisnet:access') || '{}');

      let menu = '';
      let categoria = 0;
      if (access) {
        menu = access.menu;
        categoria = Number(access.categoria);
      }
      const searchFormData = {
        proc_cod_cliente: customerId,
        proc_cod_adv_resp: attorneyInChargeId,
        description,
        dateFilterType,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
        proc_reg: lawsuitRegistrationNumber,
        proc_num_pasta: lawsuitFolderNumber,
        proc_autor: author,
        proc_reu: defendant,
        menu,
        categoria,
      };

      history.push({
        pathname: '/management/list',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };

  const initialValues: SearchData = {
    proc_cod_cliente: 0,
    proc_cod_adv_resp: 0,
    description: '',
    proc_data_ajuiz_inicio: undefined,
    proc_data_ajuiz_final: undefined,
    proc_reg: '',
    proc_num_pasta: '',
    proc_autor: '',
    proc_reu: '',
  };

  return (
    <FilterStyles>
      <Formik
        onSubmit={handleOnSubmit}
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,

        }) => (
          <form className="card search-card" onSubmit={handleSubmit}>
            <header className="search-title">
              <h3>Consulta Gerencial</h3>
            </header>

            <div className="search-grid">
              <div className="search-col">
                <Section icon={<LuUsers />} title="Cliente e responsável">
                  <div className="row r2">
                    <Field id="proc_cliente" label="Cliente">
                      <Dropdown
                        inputId="proc_cliente"
                        name="proc_cliente"
                        options={customersOptions}
                        onChange={(e) => setCustomerId(e.target.value)}
                        value={customerId}
                        optionLabel="name"
                        optionValue="value"
                        autoFocus
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                        appendTo={document.body}
                      />
                    </Field>
                    <Field id="proc_cod_adv_resp" label="Responsável">
                      <Dropdown
                        inputId="proc_cod_adv_resp"
                        name="proc_cod_adv_resp"
                        options={attorneysOptions}
                        onChange={(e) => setAttorneyInChargeId(e.target.value)}
                        value={attorneyInChargeId}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                        appendTo={document.body}
                      />
                    </Field>
                  </div>
                </Section>

                <Section icon={<LuFileSearch />} title="Identificação">
                  <div className="row r2">
                    <Field id="proc_reg" label="Nº do processo">
                      <InputText
                        id="proc_reg"
                        name="proc_reg"
                        onChange={(e) => {
                          setLawsuitRegistrationNumber(e.target.value);
                          handleChange(e);
                        }}
                        value={lawsuitRegistrationNumber}
                      />
                    </Field>
                    <Field id="proc_num_pasta" label="Pasta nº">
                      <InputText
                        id="proc_num_pasta"
                        name="proc_num_pasta"
                        onChange={(e) => setLawsuitFolderNumber(e.target.value)}
                        onBlur={handleBlur}
                        value={lawsuitFolderNumber}
                      />
                    </Field>
                  </div>
                </Section>

                <Section icon={<LuScale />} title="Partes">
                  <div className="row r2">
                    <Field id="proc_autor" label="Autor">
                      <InputText
                        id="proc_autor"
                        name="proc_autor"
                        value={author}
                        onChange={(e) => setAuthor(e.target.value)}
                      />
                    </Field>
                    <Field id="proc_reu" label="Réu">
                      <InputText
                        id="proc_reu"
                        name="proc_reu"
                        value={defendant}
                        onChange={(e) => setDefendant(e.target.value)}
                      />
                    </Field>
                  </div>
                </Section>
              </div>

              <div className="search-col">
                <Section icon={<LuCalendarRange />} title="Datas">
                  <DateFilter
                    id="data_registro"
                    label="Data de registro"
                    withMode
                    value={{
                      mode: dateFilterType === 'periodo' ? 'periodo' : 'data',
                      start: initialRegistrationDate instanceof Date ? initialRegistrationDate : null,
                      end: finalRegistrationDate instanceof Date ? finalRegistrationDate : null,
                    }}
                    onChange={(next) => {
                      setDateFilterType(next.mode);
                      setInitialRegistrationDate(next.start);
                      setFinalRegistrationDate(next.end);
                    }}
                  />
                </Section>

                <Section icon={<LuFileText />} title="Descrição">
                  <Field id="description" label="Descrição">
                    <InputTextarea
                      id="description"
                      name="description"
                      value={description || ''}
                      onChange={(e) => setDescription(e.target.value)}
                      rows={7}
                      cols={30}
                    />
                  </Field>
                </Section>
              </div>
            </div>

            <footer className="search-actions">
              <div className="buttons">
                <Button
                  icon="pi pi-undo"
                  iconPos="left"
                  label="Limpar campos"
                  className="p-button-outlined p-button-secondary"
                  type="button"
                  onClick={() => handleClear(handleReset)}
                />
                <Button
                  icon="pi pi-check"
                  iconPos="left"
                  label="Pesquisar processos"
                  type="submit"
                  disabled={isSubmitting}
                />
              </div>
            </footer>
          </form>
        )}
      </Formik>
    </FilterStyles>
  );
};

export default SearchManagement;
